import * as _ from "lodash";
import {IComponentOptions, ILogService} from "angular";
import {Application} from "../../model/Application";
import {Assessment} from "../../model/Assessment";
import {LoadingService} from "../../loading/loading.service";
import {ApplicationService} from "../../application/application.service";

class AssessmentSharingModalController {

    public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
    public resolve: any;
    public close: any;
    public dismiss: any;

    public application: Application;
    public assessment: Assessment; // for single invite
    public assessmentIds: string[]; // for bulk invites
    public newCollaborators: string[];
    public comment: string;

    private isProcessing: boolean;

    /* @ngInject */
    constructor(private $log: ILogService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.application = this.resolve.application;
        this.assessment = this.resolve.assessment;
        this.assessmentIds = this.resolve.assessmentIds;
    }

    public send() {
        this.$log.info("send()");

        const emails = this.extractEmails(this.newCollaborators);
        this.$log.debug("emails:", emails);

        this.isProcessing = true;
        this.loadingService.show();

        if (this.assessment) {
            this.applicationService.inviteCollaboratorsToAssessment(this.application.id, this.assessment.id, emails, this.comment)
                .then((updatedAssessment) => {
                    this.$log.debug("updatedAssessment", updatedAssessment);
                    this.toaster.pop({type: "success", title: "New collaborators successfully invited"});
                    this.close({$value: updatedAssessment});
                })
                .catch((reason) => {
                    this.$log.debug("Failed to invite", reason);
                    this.toaster.pop({type: "failure", title: "Failed to send invitation"});
                })
                .finally(() => {
                    this.isProcessing = false;
                    this.loadingService.hide();
                });
        } else if (this.assessmentIds && this.assessmentIds.length > 0) {
            this.$log.info("Bulk invite to", this.newCollaborators);
            this.applicationService.inviteCollaboratorsToAssessments(this.application.id, this.assessmentIds, emails, this.comment)
                .then((updatedAssessments) => {
                    this.$log.debug("updatedAssessments", updatedAssessments);
                    this.toaster.pop({type: "success", title: `New collaborators successfully invited to ${updatedAssessments.length} assessments`});
                    this.close({$value: updatedAssessments});
                })
                .catch((reason) => {
                    this.$log.debug("Failed to invite", reason);
                    this.toaster.pop({type: "failure", title: "Failed to send invitation"});
                })
                .finally(() => {
                    this.isProcessing = false;
                    this.loadingService.hide();
                });
        }
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }

    private extractEmails(newCollaborators) {
        return newCollaborators.map((entry) => {
            return entry["text"];
        });
    }

    private removeCollaborator(email: string) {
        this.applicationService.removeCollaboratorFromAssessment(this.application,
            this.assessment, email).then(() => {
                this.toaster.pop({type: "success", title: "Collaborator invitation withdrawn"});
                _.remove(this.assessment.collaborators, (collab) => {
                    return email === collab;
                });
            }
        ).catch(() => {
            this.toaster.pop({type: "error", title: "Failed to withdraw invitation"});
        });
    }
}

export const AssessmentSharingModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: AssessmentSharingModalController,
    template: require("./assessment-sharing-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/sharing-modal/assessment-sharing-modal.component.ts